// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2kK0R","col":"styles_col__2H-2N","fulfillmentStatus":"styles_fulfillmentStatus__1zLAu","emailCol":"styles_emailCol__1fp9L"};